import { Field } from "@sitecore-jss/sitecore-jss-react";
import React, { useState } from "react";

import DupSummary from "../../../components/dup/DupSummary";
import { InsuredPersonDetails } from "../../../components/Shared/personalDetails/InsuredPersonDetails";
import { Step } from "../../../components/stepIndicator/Step";
import { StepIndicator } from "../../../components/stepIndicator/StepIndicator";
import { scrollToFirstValidationMessage } from "../../../components/validationMessage/scrollToFirstValidationMessage";
import { ValidationMessage } from "../../../components/validationMessage/ValidationMessage";
import { useDidMount } from "../../../hooks/useDidMount";
import { useDupFlowContext } from "../../../hooks/useDupContext";
import { FlowLayout } from "../../FlowLayout";

interface Props {
  fields: Record<string, Field<string>>;
}

export const DupFlowStepTwo = (props: Props) => {
  const [loading, setLoading] = useState(false);
  const { data, modelState, setModelState, goToStepThree, currentStep, goBack, setters } = useDupFlowContext();

  const goToStep1 = () => {
    goBack(1, props.fields.Step1Path.value);
  };

  const goToStep3 = async () => {
    try {
      setLoading(true);
      await goToStepThree(props.fields.Step3Path.value);
    } catch {
      setLoading(false);
      scrollToFirstValidationMessage();
    }
  };

  useDidMount(() => {
    if (currentStep !== 2) {
      goBack(1, props.fields.Step1Path.value);
    }
  });

  const handleStepClick = (index: number) => () => {
    if (index === 0) {
      goBack(1, props.fields.Step1Path.value);
    }
  };

  if (currentStep !== 2) {
    return null;
  }

  return (
    <>
      <StepIndicator handleClick={handleStepClick} activeStepIndex={1}>
        <Step label={props.fields.step1Name.value} labelMobile={props.fields.step1MobileName.value} />
        <Step label={props.fields.step2Name.value} labelMobile={props.fields.step2MobileName.value} />
        <Step label={props.fields.step3Name.value} labelMobile={props.fields.step3MobileName.value} />
        <Step label={props.fields.step4Name.value} labelMobile={props.fields.step4MobileName.value} />
      </StepIndicator>
      <FlowLayout
        Sidebar={
          <DupSummary
            {...props}
            submitButtonProps={{
              id: "viewQuoteButtonId",
              children: props.fields.ViewQuoteSubmitButtonText.value,
              loading,
              onClick: goToStep3,
            }}
          />
        }
        {...props}
      >
        <ValidationMessage id="global" modelState={modelState} property="Global" />

        {data.insuredPersons.map((insuredPerson, index) => (
          <InsuredPersonDetails
            key={insuredPerson.personId}
            index={index}
            fields={props.fields}
            data={insuredPerson}
            setModelState={setModelState}
            onUpdateInsured={setters.updateInsuredData}
            handleEditDateOfBirth={goToStep1}
            modelState={modelState}
            hideAddressAndContactDetails={index > 0}
            isSecondInsured={index > 0 && !insuredPerson.isChild}
          />
        ))}
      </FlowLayout>
    </>
  );
};
